import React from "react";
import { useDispatch } from "react-redux";
import { clickOnElemnt, rgba } from "../../../../../helpers";
import { selectElement } from "../../../../../redux/slice/themeSlice";
import { useSelector } from "react-redux";

const Logo = () => {
  const dispatch = useDispatch();
  const { theme, selectedElement } = useSelector(
    (state) => state?.themeProvider
  );

  return (
    <div
      className="scale-[1.03] -mt-[3px] relative py-4 flex items-center gap-4 transition-all duration-100 z-60 border-slate-700 editable-element"
      id="logo"
      onClick={(e) => {
        dispatch(selectElement(clickOnElemnt({ event: e })));
      }}
      {...(theme?.customiseLogo?.backgroundColor && {
        style: { backgroundColor: rgba(theme?.customiseLogo?.backgroundColor) },
      })}
    >
      <div className="h-10 overflow-hidden mx-auto">
        <img
          className="w-full h-full object-contain"
          src={
            theme?.logo instanceof File
              ? URL.createObjectURL(theme?.logo)
              : theme?.logo?.url ||
                theme?.logo ||
                "/static/media/logo.ee1b5305b002c31c0508.png"
          }
          alt="Logo"
        />
      </div>
    </div>
  );
};

export default Logo;
